export default "__VITE_ASSET__5b7c2fae__"